import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';

class DeliveryChallanSkuAPIClient extends CrudApiClient {
  itemFormat?: string;

  constructor(itemFormat?: string) {
    super(GATEWAY_API_URL + '/deliverychallan/:deliveryChallanId/sku');
    this.itemFormat = itemFormat;
  }

  resolveParameterizedUrlVariables(meta: MetaQuery | undefined) {
    let url = this.baseURL?.replace(':deliveryChallanId', meta?.deliveryChallanId);
    if (this.itemFormat) {
      url += '/' + this.itemFormat;
    }
    return url;
  }

  transformNode = (node: any) => {
    if (!this.itemFormat) node.quantity = 1;
    else if (this.itemFormat == 'wondersoft') node.BatchDescription = '';

    return node;
  };
}

export default DeliveryChallanSkuAPIClient;
